
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Flow`}</h2>
    <p>{`styled-components has first-class `}<a parentName="p" {...{
        "href": "https://flowtype.org"
      }}>{`Flow`}</a>{` support to help
you find typing errors while using our public API.`}</p>
    <p>{`To use Flow with the public api of styled-components we recommend that you use the library definition in `}<inlineCode parentName="p">{`flow-typed`}</inlineCode>{`.
To install it you can use the `}<inlineCode parentName="p">{`flow-typed`}</inlineCode>{` cli or download it manually from the git repository and store it in
a `}<inlineCode parentName="p">{`flow-typed/`}</inlineCode>{` folder in the same directory with your `}<inlineCode parentName="p">{`flowconfig`}</inlineCode>{`.`}</p>
    <h3>{`Installing the definitions`}</h3>
    <pre><code parentName="pre" {...{}}>{`npm i -g flow-typed # if you do not already have flow-typed
flow-typed install styled-components@<version>
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`If you are on npm >= 5.2 you could simply use `}<a parentName="p" {...{
          "href": "https://github.com/zkat/npx"
        }}>{`npx`}</a></p>
    </blockquote>
    <h3>{`Ignore styled-components source`}</h3>
    <p>{`You should add the following lines to your `}<inlineCode parentName="p">{`.flowconfig`}</inlineCode>{`, if you run into Flow errors, coming from the styled-components
package in your `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory.`}</p>
    <pre><code parentName="pre" {...{}}>{`[ignore]
.*/node_modules/styled-components/.*
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;